import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "edit-workout",
  class: "view"
}
const _hoisted_2 = { class: "container" }

import { computed, watch, onBeforeMount, ComputedRef } from 'vue'
  import { useRoute } from 'vue-router'

  import WorkoutEdition from '@/components/Workout/WorkoutEdition.vue'
  import {
    AUTH_USER_STORE,
    SPORTS_STORE,
    WORKOUTS_STORE,
  } from '@/store/constants'
  import { ISport } from '@/types/sports'
  import { IUserProfile } from '@/types/user'
  import { IWorkoutData } from '@/types/workouts'
  import { useStore } from '@/use/useStore'

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const route = useRoute()
  const store = useStore()

  const authUser: ComputedRef<IUserProfile> = computed(
    () => store.getters[AUTH_USER_STORE.GETTERS.AUTH_USER_PROFILE]
  )
  const sports: ComputedRef<ISport[]> = computed(
    () => store.getters[SPORTS_STORE.GETTERS.SPORTS]
  )
  const workoutData: ComputedRef<IWorkoutData> = computed(
    () => store.getters[WORKOUTS_STORE.GETTERS.WORKOUT_DATA]
  )

  onBeforeMount(() => {
    store.dispatch(WORKOUTS_STORE.ACTIONS.GET_WORKOUT_DATA, {
      workoutId: route.params.workoutId,
    })
  })

  watch(
    () => route.params.workoutId,
    async (newWorkoutId) => {
      if (!newWorkoutId) {
        store.commit(WORKOUTS_STORE.MUTATIONS.EMPTY_WORKOUT)
      }
    }
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(WorkoutEdition, {
        authUser: _unref(authUser),
        sports: _unref(sports),
        workout: _unref(workoutData).workout,
        loading: _unref(workoutData).loading
      }, null, 8, ["authUser", "sports", "workout", "loading"])
    ])
  ]))
}
}

})